export default "__VITE_ASSET__DPhh3_6Z__";